export const onPressEnterModal = (handleSubmitBtn: Function, isDisable?: boolean) => (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' && !isDisable) {
        handleSubmitBtn(e);
    }
};
